import axios from 'axios';
import { settings } from '@/plugins/settings';

export interface ICommunityServiceProvider {
  id: number;
  name: string;
  active: boolean;
  channel_inconsistency: boolean;
}

const base = (communityId: number) => settings.endpoint + 'communities/' + communityId + '/service-providers';
const providerBase = (serviceProviderId: number) => settings.endpoint + 'serviceProviders/' + serviceProviderId + '/communities';

export interface IServiceProviderCommunity {
  id: number;
  name: string;
  assigned: boolean;
  active: boolean;
}

export const communityServiceProviderService = {
  fetchByCommunity(communityId: number): Promise<ICommunityServiceProvider[]> {
    return axios({ url: base(communityId), method: 'GET' }).then((response: any) => {
      const d = response && response.data;
      if (d && Array.isArray(d.data)) return d.data;
      if (Array.isArray(d)) return d;
      return [];
    });
  },

  fetchByServiceProvider(serviceProviderId: number): Promise<IServiceProviderCommunity[]> {
    return axios({ url: providerBase(serviceProviderId), method: 'GET' }).then((response: any) => {
      const d = response && response.data;
      if (d && Array.isArray(d.data)) return d.data;
      if (Array.isArray(d)) return d;
      return [];
    });
  },

  create(communityId: number, serviceProviderId: number): Promise<any> {
    return axios({
      url: base(communityId),
      method: 'POST',
      data: { service_provider_id: serviceProviderId },
    }).then((response: any) => response.data);
  },

  destroy(communityId: number, serviceProviderId: number): Promise<void> {
    return axios({
      url: base(communityId) + '/' + serviceProviderId,
      method: 'DELETE',
    }).then(() => {});
  },

  moveUp(communityId: number, serviceProviderId: number): Promise<any> {
    return axios({
      url: base(communityId) + '/' + serviceProviderId + '/up',
      method: 'PATCH',
    }).then((response: any) => response.data);
  },

  moveDown(communityId: number, serviceProviderId: number): Promise<any> {
    return axios({
      url: base(communityId) + '/' + serviceProviderId + '/down',
      method: 'PATCH',
    }).then((response: any) => response.data);
  },
};
